<template>
	<div class="bg-white px-3 index" style="margin: 0 26px; margin-bottom: 0 !important">
		<el-tabs v-model="tabIndex" @tab-click="getList">
			<el-tab-pane :label="tab.name" :key="tabI" v-for="(tab, tabI) in tabbars"></el-tab-pane>
		</el-tabs>

		<button-search ref="buttonSearch" placeholder="要搜索的商品名称" @search="searchEvent">
			<!-- 左边 -->
			<template #left>
				<router-link :to="{ name: 'shop_goods_create' }" class="mr-2">
					<el-button type="success" size="mini">发布商品</el-button>
				</router-link>
				<el-button type="warning" size="mini" v-if="tab === 'delete'" @click="doEvent('restore')">恢复商品
				</el-button>
				<el-button type="danger" size="mini" v-if="tab === 'delete'" @click="doEvent('destroy')">彻底删除
				</el-button>
				<el-button type="danger" size="mini" v-if="tab != 'delete'" @click="deleteAll">批量删除</el-button>
				<el-button size="mini" v-if="tab === 'all' || tab === 'off'" @click="changeStatus(1)">上架</el-button>
				<el-button size="mini" v-if="tab === 'all' || tab === 'saling'" @click="changeStatus(0)">下架</el-button>
			</template>
			<!-- 高级搜索表单 -->
			<template #form>
				<el-form inline ref="form" :model="form" label-width="80px">
					<el-form-item label="商品名称" class="mb-0">
						<el-input v-model="form.title" placeholder="商品名称" size="mini"></el-input>
					</el-form-item>
					<el-form-item label="商品分类" class="mb-0">
						<el-select v-model="form.category_id" filterable placeholder="请选择商品分类" size="mini">
							<el-option v-for="item in cateOptions" :key="item.id" :label="item | tree" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="mb-0">
						<el-button type="info" size="mini" @click="searchEvent">
							搜索</el-button>
						<el-button size="mini" @click="clearSearch">清空筛选条件</el-button>
					</el-form-item>
				</el-form>
			</template>
		</button-search>

		<!-- 商品列表 -->
		<el-table border class="mt-3" :data="tableData" style="width: 100%" :height="heights"
			@selection-change="handleSelectionChange" :row-key="getRowKeys">
			<el-table-column type="selection" width="45" align="center" :reserve-selection="true">
			</el-table-column>
			<el-table-column align="center" prop="id" width="70" label="ID">
			</el-table-column>
			<el-table-column label="商品" width="300">
				<template slot-scope="scope">
					<div class="media">
						<img class="mr-3" v-if="scope.row.cover" style="width: 60px; height: 60px"
							:src="scope.row.cover[0].url" />
						<div class="media-body">
							<p class="mt-0">{{ scope.row.title }}</p>
							<p class="mb-0">分类：{{ scope.row.category?scope.row.category.name:'' }}</p>
							<p class="mb-0">时间：{{ scope.row.create_time?scope.row.create_time:'' }}</p>
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="sale_count" width="70" label="实际销量">
			</el-table-column>
			<el-table-column prop="status" align="center" label="商品状态" width="60">
				<template slot-scope="scope">
					<span class="badge"
						:class="scope.row.status ? 'badge-success' : 'badge-danger'">{{ scope.row.status ? "上架" : "仓库" }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="status" align="center" width="120" label="审核状态">
				<template slot-scope="scope">
					<div class="d-flex flex-column" v-if="!scope.row.ischeck">
						<el-button type="success" size="mini" @click="checkGoods(scope.row, 1)" plain>审核通过
						</el-button>

						<el-button class="ml-0 mt-2" type="danger" size="mini" @click="checkGoods(scope.row, 2)" plain>
							审核拒绝
						</el-button>
					</div>
					<span v-else>{{ scope.row.ischeck === 1 ? "通过" : "拒绝" }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="stock" align="center" width="90" label="总库存">
			</el-table-column>
			<el-table-column prop="pprice" align="center" label=" 价格(元)" width="120">
				<template slot-scope="scope">
					<span class="text-danger">￥{{ scope.row.min_price }}</span>
					<span>/</span>
					<span class="text-muted">￥{{ scope.row.min_oprice }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="base_sale_count" align="center" width="90" label="已售量">
			</el-table-column>
			<el-table-column prop="base_sale_count" align="center" width="90" label="第二件半价">
				<template slot-scope="{row}">
					{{({0:'否',1:'是'})[row.double_status]}}
				</template>
			</el-table-column>
			<el-table-column prop="base_sale_count" align="center" width="90" label="是否热销">
				<template slot-scope="{row}">
					{{({0:'否',1:'是'})[row.is_hot]}}
				</template>
			</el-table-column>
			<el-table-column prop="base_sale_count" align="center" width="90" label="展示平台">
				<template slot-scope="{row}">
					{{({1:'快康',2:'正汉'})[row.data_source]}}
				</template>
			</el-table-column>
			<el-table-column prop="category.name" align="center" width="90" label="商品类型"></el-table-column>
			<el-table-column align="center" label="操作">
				<template slot-scope="scope">
					<el-button type="text" size="mini" @click="navigate('/shop/goods/create', scope.row.id)">基础设置
					</el-button>
					<el-button type="text" size="mini" @click="navigate('/shop/goods/sku', scope.row.id)">商品规格
					</el-button>
					<!-- :class="(scope.row.sku_type == 0 && !scope.row.sku_value) ||(scope.row.sku_type == 1 && !scope.row.goods_skus.length) ? 'text-danger': ''" -->
					<el-button type="text" size="mini" @click="navigate('/shop/goods/attr', scope.row.id)">商品属性
					</el-button> <!-- :class="scope.row.goods_attrs.length == 0 ? 'text-danger' : ''" -->
					<el-button type="text" size="mini" @click="navigate('/shop/goods/banner', scope.row.id)">媒体设置
					</el-button> <!-- :class="scope.row.goods_banner.length == 0 ? 'text-danger' : ''" -->
					<el-button type="text" size="mini" @click="navigate('/shop/goods/content', scope.row.id)"
						:class="!scope.row.content ? 'text-danger' : ''">商品详情</el-button>
					<el-button type="text" size="mini">折扣设置</el-button>
					<el-button type="text" size="mini" @click="deleteItem(scope.row)">删除商品</el-button>
					<el-button type="text" size="mini" @click="cloneClick( scope.row)">克隆商品</el-button>
					<el-button type="text" size="mini" @click="pinglunClick( scope.row)">虚拟评论</el-button>
					<el-button type="text" size="mini" v-if="scope.row.category_id==392"
						@click="qiangduiClick(scope.row)">抢兑设置</el-button>

				</template>
			</el-table-column>
		</el-table>
		<div style="height: 60px"></div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white"
			style="bottom: 0; left: 200px; right: 0; z-index: 100">
			<div style="flex: 1" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper" :total="page.total" @size-change="handleSizeChange"
					@current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</el-footer>


		<el-dialog title="虚拟评论" :visible.sync="pldialogs" top="50px" width="60%" center class="dialogs"
			:close-on-click-modal='false'>
			<el-divider></el-divider>
			<div class="dialog-ibox-content">
				<el-row>
					<el-col :span="12">
						<div class="pl_box" :class="{nullpl_b:pl_length}" v-infinite-scroll="load"
							infinite-scroll-disabled="disabled">
							<div class="item" v-for="(item,index) in pllists" :key="index">
								<div class="info">
									<div class="u-f u-ac">
										<div class="u_ava">
											<el-image style="width: 37px; height: 37px" :src="item.avatar" fit="cover">
											</el-image>
										</div>
										<div class="u_name">{{item.create_user_str?item.create_user_str:'用户'}}
										</div>
									</div>

									<div class="u-f u-ac">
										<el-rate v-model="item.rating" disabled></el-rate>
										<i class="el-icon-delete delbtn" @click="delpl(item,index)"></i>
									</div>
								</div>
								<div class="pl_text">{{item.reply_content}}</div>
								<div class="img_box" v-if="item.file_info&&item.file_info.length>0">
									<el-image style="width: 100px; height: 100px" v-for="(img,ind) in item.file_info"
										:key="ind" :src="img.url" fit="cover" class="pl_img"
										:preview-src-list="[img.url]" :z-index='10000'>
									</el-image>
								</div>
								<div class="time">{{item.create_time}}</div>
							</div>
							<p v-if="plmoreloading" class="pl_load">加载中···</p>
							<div class="nullpl" v-if="pl_length">暂无评论</div>
						</div>
					</el-col>
					<el-col :span="12">
						<el-form :model="plForm" ref="dsForm" label-width="90px" :rules="plrules"
							class="demo-ruleForm forms-lines">
							<el-form-item label="用户：" prop="yh">
								<el-select v-model="plForm.yh" placeholder="请选择" size="small" filterable
									@change="selectUser(plForm.yh)">
									<el-option v-for="item in yh_options" :key="item.id" :label="item.username"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="评价：" required>
								<div>
									<el-rate v-model="plForm.rating"></el-rate>
								</div>
							</el-form-item>
							<el-form-item label="评论：" prop="reply_content">
								<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="plForm.reply_content">
								</el-input>
							</el-form-item>
							<el-form-item label="图片：">
								<el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
									:headers="{ token:$store.state.user.token }" :limit="3"
									:data="{ image_class_id:'72',file_type:'1' }" :file-list="plForm.lb_mapList"
									:on-success="uploadSuccess" :on-remove="uploadRmove" list-type="picture-card">
									<i class="el-icon-plus"></i>
								</el-upload>
							</el-form-item>
						</el-form>
					</el-col>
				</el-row>

			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="plsubmit('dsForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
				<el-button @click="pldialogs = false" size="small">取 消</el-button>
			</span>
		</el-dialog>

		<!-- 抢兑 -->
		<el-dialog title="奖品设置" :visible.sync="timelistdetail" top="50px" width="60%" class="dialogs">
			<el-divider></el-divider>
			<Contentvotelist ref="timelist" />
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="timelistdetail=false" size="small">确定</el-button>
			</span>
		</el-dialog>



	</div>
</template>

<script>
	import Contentvotelist from "./qiangdui.vue";
	import buttonSearch from "@/components/common/button-search.vue";
	import common from "@/common/mixins/common.js";
	import pageVue from '../../../components/xaoi/page.vue';
	export default {
		mixins: [common],
		inject: ["layout"],
		components: {
			buttonSearch,
			Contentvotelist
		},
		data() {
			return {
				preUrl: "goods",

				tabIndex: 0,
				tabbars: [{
						name: "全部",
						key: "all"
					},
					{
						name: "审核中",
						key: "checking"
					},
					{
						name: "出售中",
						key: "saling"
					},
					{
						name: "已下架",
						key: "off"
					},
					{
						name: "库存预警",
						key: "min_stock"
					},
					{
						name: "回收站",
						key: "delete"
					},
				],
				form: {
					title: "",
					category_id: "",
				},
				tableData: [],
				cateOptions: [],
				pldialogs: false,
				yh_options: [],
				mapListed: [],
				plForm: {
					yh: '',
					rating: 5,
					reply_content: '',
					lb_mapList: []
				},
				plrules: {
					yh: [{
						required: true,
						message: '请选择用户',
						trigger: 'blur'
					}],
					reply_content: [{
						required: true,
						message: '请填写内容',
						trigger: 'blur'
					}]
				},
				plloading: false,
				subloading: false,
				pllists: [],
				selectUserdata: '',
				eid: '',
				is_null_pllist: false,
				plpage: 1,
				plmoreloading: false,
				pl_length: false,
				heights: null,
				timelistdetail: false,

			};
		},
		filters: {
			tree(item) {
				if (item.level == 0) {
					return item.name;
				}
				let str = "";
				for (let i = 0; i < item.level; i++) {
					str += i == 0 ? "|--" : "--";
				}
				return str + " " + item.name;
			},
		},
		computed: {
			tab() {
				return this.tabbars[this.tabIndex].key;
			},
			params() {
				let str = "";
				for (let key in this.form) {
					let val = this.form[key];
					if (val) {
						str += `&${key}=${this.form[key]}`;
					}
				}
				return str;
			},
			disabled() {
				return this.is_null_pllist || this.plmoreloading
			}
		},
		created() {
			if (sessionStorage.getItem('xuniUsers')) {
				this.yh_options = JSON.parse(sessionStorage.getItem('xuniUsers'))
			} else {
				this.getxnUser()
			}

		},
		mounted() {
			this.getHeight()
		},
		methods: {
			// 获取高度
			getHeight() {
				let that = this;
				that.heights = window.innerHeight - 310 + 'px'
				window.onresize = () => {
					that.heights = window.innerHeight - 310 + 'px'
				}
			},
			navigate(name, id) {
				this.$router.push({
					path: name,
					query: {
						id: id
					},
				});
			},
			// 获取请求列表分页url
			getListUrl() {
				return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&tab=${this.tab}${this.params}`;
			},
			getListResult(e) {
				this.tableData = e.list;
				this.cateOptions = e.cates;
			},
			getRowKeys(row) {
				return row.id; // id为列表数据的唯一标识
			},
			// 上下架
			changeStatus(item) {
				item.status = item.status === 1 ? 0 : 1;
			},
			// 清空筛选条件
			clearSearch() {
				this.form = {
					title: "",
					category_id: "",
				};
			},
			// 搜索事件
			searchEvent(e = false) {
				// 简单搜索
				if (typeof e === "string") {
					this.form.title = e;
				}
				// 高级搜索
				this.getList();
			},
			doEvent(key) {
				if (this.ids.length === 0) {
					return this.$message({
						type: "error",
						message: "请选择要操作的商品",
					});
				}
				this.showLoading();
				this.axios
					.post(
						"/admin/goods/" + key, {
							ids: this.ids,
						}, {
							token: true,
						}
					)
					.then((res) => {
						this.$message({
							type: "success",
							message: "操作成功",
						});
						this.getList();
						this.hideLoading();
					})
					.catch((err) => {
						this.hideLoading();
					});
			},
			// 上下架
			changeStatus(status) {
				if (this.ids.length === 0) {
					return this.$message({
						type: "error",
						message: "请选择要操作的商品",
					});
				}
				this.showLoading();
				this.axios
					.post(
						"/admin/goods/changestatus", {
							ids: this.ids,
							status,
						}, {
							token: true
						}
					)
					.then((res) => {
						this.$message({
							type: "success",
							message: "操作成功",
						});
						this.getList();
						this.hideLoading();
					})
					.catch((err) => {
						this.hideLoading();
					});
			},
			checkGoods(item, ischeck) {
				this.layout.showLoading();
				this.axios
					.post(
						"/admin/goods/" + item.id + "/check", {
							ischeck,
						}, {
							token: true
						}
					)
					.then((res) => {
						this.getList();
						this.$message({
							type: "success",
							message: "操作成功",
						});
						this.layout.hideLoading();
					})
					.catch((err) => {
						this.layout.hideLoading();
					});
			},
			cloneClick(row) {
				this.$confirm('此操作将克隆该商品, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.layout.showLoading();
					this.axios
						.post(
							"/admin/pc/goods/copyGoods", {
								id: row.id,
								title: row.title,
							}, {
								token: true
							}
						)
						.then((res) => {
							this.getList();
							this.$message({
								type: "success",
								message: "操作成功",
							});
							this.layout.hideLoading();
						})
						.catch((err) => {
							this.layout.hideLoading();
						});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			getxnUser() {
				this.axios
					.post(
						"/admin/h5/fictitiousUsers", {
							page: 1,
							page_count: 3000
						}, {
							token: true
						}
					)
					.then((res) => {
						this.yh_options = res.data.data.list
						sessionStorage.setItem('xuniUsers', JSON.stringify(res.data.data.list))
					})
					.catch((err) => {

					});
			},
			async pinglunClick(row) {
				this.eid = row.id
				this.plForm.yh = ''
				this.plForm.rating = 5
				this.plForm.reply_content = ''
				this.plForm.lb_mapList = []
				this.mapListed = []
				this.pllists = []
				this.pldialogs = true
				this.plpage = 1
				this.plmoreloading = false
				this.is_null_pllist = false
				await this.getpllist()
			},
			load() {
				this.getpllist()
			},
			async getpllist() {
				this.pl_length = false
				this.plmoreloading = true
				await this.axios
					.post(
						"/admin/AllComment/HgetComments", {
							data_id: this.eid,
							source: 5,
							page: this.plpage,
							page_count: 15
						}, {
							token: true
						}
					)
					.then((res) => {
						let data = res.data.data.list
						if (data.length > 0) {
							this.pllists = this.pllists.concat(data)
							this.plpage++
						} else {
							this.is_null_pllist = true
						}
						this.plmoreloading = false
						this.plloading = false
						if (this.pllists.length == 0) {
							this.pl_length = true
						}

					})
					.catch((err) => {

					});
			},
			uploadSuccess(response, file, fileList) {
				let that = this
				if (response.code == "201") {
					that.$nextTick(() => {
						let mainImg = that.$refs.upload;
						if (mainImg) {
							mainImg.uploadFiles.forEach((element, index) => {
								if (file.uid == element.uid) {
									mainImg.uploadFiles.splice(index, 1)
								}
							});
						}
					})
					that.$alert(response.msg)
					return;
				}
				that.$message({
					message: '上传成功',
					type: 'success'
				});
				that.mapListed.push(response.data)
			},
			uploadRmove(file, fileList) {
				var index = this.mapListed.findIndex(item => item.id == file.id)
				this.mapListed.splice(index, 1)
			},
			selectUser(val) {
				this.yh_options.forEach(e => {
					if (e.id == val) {
						this.selectUserdata = e
					}
				})
			},
			plsubmit(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.subloading = true
						this.axios
							.post(
								"/admin/AllComment/Hsave", {
									create_user: this.selectUserdata.id,
									author: this.selectUserdata.id,
									data_id: this.eid,
									reply_content: this.plForm.reply_content,
									create_user_text: this.selectUserdata.username,
									avatar: this.selectUserdata.avatar,
									source: 5,
									is_fictitious_user: 1,
									rating: this.plForm.rating,
									file_info: this.mapListed,
								}, {
									token: true
								}
							)
							.then((res) => {
								if (res.data.code == 200) {
									this.$message.success('评论成功！')
									this.plpage = 1
									this.pllists = []
									this.getpllist()

								} else {
									this.$message.error(res.data.msg)

								}
								this.subloading = false

							})
							.catch((err) => {

							});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			delpl(item, index) {
				this.$confirm('确认删除此评论, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.axios
						.post(
							"/admin/AllComment/Hdel", {
								id: item.id,
							}, {
								token: true
							}
						)
						.then((res) => {
							if (res.data.code == 200) {
								this.$message.success('评论删除成功！')
								this.pllists.splice(index, 1)
								if (this.pllists.length == 0) {
									this.pl_length = true
								}
							} else {
								this.$message(res.data.msg)
							}
						})
						.catch((err) => {});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			qiangduiClick(row) {
				this.timelistdetail = true
				this.$nextTick(() => {
					this.$refs.timelist.textId = row.id
					this.$refs.timelist.getlist(row.id)
					// this.$refs.votelist.votelist=row.content
				})
			}
		},
	};
</script>

<style scoped lang='scss'>
	.index {
		border-radius: 6px;
		padding-bottom: 10px;
	}

	.el-form-item {
		margin-bottom: 22px !important;
	}

	.pl_box {
		border: 1px solid rgb(247, 247, 247);
		border-radius: 5px;
		// box-shadow: 0 0 3px 0 rgba($color: #000000, $alpha: .1);
		height: 600px;
		overflow: auto;
		padding: 10px;

		.item {
			.info {
				display: flex;
				align-items: center;
				justify-content: space-between;

				.u_ava {
					border-radius: 50%;
					overflow: hidden;

					.el-image {
						display: block;
					}
				}

				.u_name {
					margin-left: 5px;
				}

				.delbtn {
					color: red;
					cursor: pointer;
					font-size: 16px;
				}
			}

			.pl_text {
				padding: 5px 0;
			}

			.img_box {
				.pl_img {
					margin-right: 5px;
				}
			}

			.time {
				font-size: 12px;
			}
		}

		.pl_load {
			text-align: center;
			font-size: 14px;
		}
	}

	.nullpl_b {
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>